// What starts the Academy: the content is loaded and the
// local mirror keeps itself in step with the edge (the queue left by
// the last session is flushed, a refresh is asked for, and the triggers that
// follow are armed). It runs from the app shell, not from a learn screen, so
// work done offline yesterday reaches the edge on whatever screen the app opens.
import { useEffect } from "react";
import { curriculumVersion } from "./curriculum";
import { startAccountBinding } from "./account";

export function useAcademyStartup(): void {
  // The depth's own record keeps itself in step on the same terms as the path.
  // Signing in binds the progress to the account; signing out sets it aside after the last flush.
  useEffect(() => startAccountBinding(), []);
  useEffect(() => {
    let cancelled = false;
    void import("./depth/sync")
      .then((sync) => {
        if (!cancelled) sync.startDepthSync();
        return sync;
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);
  useEffect(() => {
    let cancelled = false;
    // No lesson is downloaded until a learn screen opens: the version is known without the content.
    const sync = import("./sync");
    curriculumVersion()
      // The version could not be read: sync still runs, it just cannot say which version it saw.
      .catch(() => undefined)
      .then(async (version) =>
        cancelled
          ? undefined
          : (await sync).startLearnSync(
              version === undefined ? {} : { curriculumVersion: version },
            ),
      )
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);
}
